import { Class } from '../models/class';
import { addressMapper } from './address.mapper';
import { dateMapper } from './date.mapper';

/**
 * Map from dto.
 * @param {object} dto Dto.
 * @returns {Class}
 */
function fromDto(dto) {
  const address = dto.class_location?.address ? addressMapper.fromDto(dto.class_location.address) : {};
  return {
    arriveTime: dto.arrive_time,
    categoryId: dto.category_id,
    classDate: dateMapper.fromDto(dto.class_date),
    classLocation: {
      address: {
        ...address,
        county: dto.class_location?.address?.county,
        importId: dto.class_location?.address?.import_id,
        street2: dto.class_location?.address?.street2,
        zipCode: {
          areaCode: dto.class_location?.address?.zip_code?.areacode,
          city: dto.class_location?.address?.zip_code?.city,
          county: dto.class_location?.address?.zip_code?.county,
          countyFip: dto.class_location?.address?.zip_code?.county_fip,
          dayLightSavings: dto.class_location?.address?.zip_code?.daylight_savings,
          elevation: dto.class_location?.address?.zip_code?.elevation,
          id: dto.class_location?.address?.zip_code?.id,
          latitude: dto.class_location?.address?.zip_code?.latitude,
          longitude: dto.class_location?.address?.zip_code?.longitude,
          stateCode: dto.class_location?.address?.zip_code?.state_code,
          timezone: dto.class_location?.address?.zip_code?.timezone,
          zip: dto.class_location?.address?.zip_code?.zip,
        },
      },
      capacity: dto.class_location?.capacity,
      displayName: dto.class_location?.display_name,
      id: dto.class_location?.id,
      name: dto.class_location?.name,
      parkingInfo: dto.class_location?.parking_info,
      restrictionsInfo: dto.class_location?.restrictions_info,
      workNumber: dto.class_location?.work_number,
    },
    endTime: dto.end_time,
    examArriveTime: dto.exam_arrive_time,
    examEndTime: dto.exam_end_time,
    examStartTime: dto.exam_start_time,
    id: dto.id,
    isAlmostFull: dto.is_almost_full,
    isInstantResults: dto.is_instant_results ?? false,
    language: {
      id: dto.language.id,

      name: dto.language.name,
      code: dto.language.code,
    },
    name: dto.name,
    seatsLeft: dto.seats_left,
    seatsTaken: dto.seats_taken,
    startTime: dto.start_time,
    statusId: dto.status_id,
    isPublic: dto.is_public,
  };
}

export const classMapper = {
  fromDto,
};
